<template>
  <Modal v-model="visible" :mask-closable="false" title="变更续保状态" width="500" class="my-modal">
    <Form ref="form" :model="formData" :label-width="110" class="page-form">
      <FormItem label="续保状态" prop="payState" :rules="$units.formRule.required(`请选择`)" class="full">
        <RadioGroup v-model="formData.payState">
          <Radio style="margin-right: 20px" label="2">已续保</Radio>
          <Radio style="margin-right: 20px" label="3">未续保</Radio>
        </RadioGroup>
      </FormItem>
      <template v-if="formData.payState == 2">
        <FormItem label="新保单号" prop="newPolicyNo" class="full" key="newPolicyNo">
          <Input v-model="formData.newPolicyNo" placeholder="请输入" />
        </FormItem>
        <FormItem label="实际续保日期" prop="payTime" class="full" key="payTime">
          <DatePicker type="date" :value="formData.payTime" @on-change="$set(formData, 'payTime', $event)" placeholder="请选择" transfer></DatePicker>
        </FormItem>
      </template>
      <template v-else-if="formData.payState == 3">
        <FormItem label="原因" prop="remark" class="full" :rules="$units.formRule.required(`请输入`)" key="remark">
          <Input v-model="formData.remark" type="textarea" placeholder="请输入" :autosize="{ minRows: 2 }" />
        </FormItem>
      </template>
    </Form>
    <div slot="footer">
      <Button type="primary" ghost @click="visible = false">取消</Button>
      <Button type="primary" @click="ok">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  props: [],
  data() {
    return {
      visible: false,
      formData: {}
    };
  },

  methods: {
    open(data) {
      if (data.orderId) {
        this.$notice.error('已创建续保订单，不可变更续保状态');
        return;
      }
      this.visible = true;
      this.formData = {
        id: data.id,
        policyNo: data.policyNo,
        payState: ''
      };
      this.clearValidate();
    },

    ok() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = Object.assign({}, this.formData);
        if (formData.payState == 2) {
          delete formData.remark;
          if (formData.newPolicyNo && !formData.payTime) {
            return this.$notice.error('请选择实际续保日期');
          }
          if (!formData.newPolicyNo && formData.payTime) {
            return this.$notice.error('请输入新保单号');
          }
        } else if (formData.payState == 3) {
          delete formData.newPolicyNo;
          delete formData.payTime;
        }
        this.$http({
          url: `/buz/groupPolicyRenewalRecord/edit`,
          type: 'POST',
          data: formData
        }).then(res => {
          this.$notice.success('操作成功');
          this.visible = false;
          this.$emit('reload');
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>